import {observer} from "mobx-react-lite";
import React from "react";
import {EventBookingStatus} from "../../../shared/enums/eventBookingStatus";
import EventBookingsTable from "../eventBookingsTable/eventBookingsTable";
import Tag from "../../atoms/tag/tag";
import {useTranslation} from "react-i18next";
import {EventPaidType} from "../../../shared/enums/eventPaidType";
import {useStores} from "../../../stores/useStores";

const EventBookingsCancelledTable: React.FC = () => {
  const {t} = useTranslation(["translation", "event"]);

  const {
    domainStore: {eventsDomainStore},
    uiStore: {eventsUiStore}
  } = useStores();
  const eventDetails = eventsDomainStore.editableEvent;
  const eventBookings = eventsUiStore.cancelledEventBookings;

  return (
    <>
      {!!eventBookings.length && (
        <EventBookingsTable
          eventBookings={eventBookings}
          type={EventBookingStatus.Cancelled}
          header={
            <div className="booking-tally" data-testid="cancelled-tally">
              {t("event:titles.cancelled")}
              {!eventsUiStore.isLoading && (
                <Tag
                  text={eventBookings.length.toString()}
                  type={
                    (
                      eventDetails.releaseDate.date !== null
                        ? eventDetails.isPassedBookingDeadline
                        : eventDetails.isPassedEndDate
                    )
                      ? "light"
                      : "negative"
                  }
                />
              )}
            </div>
          }
          isSortingEnabled={false}
          isPaidEvent={
            eventDetails?.priceDetails?.paidType.text === EventPaidType.fixed
          }
        />
      )}
    </>
  );
};

export default observer(EventBookingsCancelledTable);
